import fetch from '@/common/utils/serFetch'
import { APICUS } from '@public/utils/const'
const moduleList = {
  thirdService: `${APICUS}/thirdService`, // 物流轨迹
  outCustomerService: `${APICUS}/outCustomerService`, // 外包在线客服
  serviceManagement: `${APICUS}/serviceManagement`, // 客服 服务商管理
  customerIncomeStatistics: `${APICUS}/customerIncomeStatistics`, // 外包客服进线
  workOrder: `${APICUS}/workOrder`, // 服务商普通工单
  workOrderInfo: `${APICUS}/workOrderInfo`, // 服务商普通工单 详情
  claimWorkOrderInfo: `${APICUS}/claimWorkOrderInfo`, // 服务商理赔工单 详情
  claimManage: `${APICUS}/claimManage`, // 服务商理赔工单
  report: `${APICUS}/report`, // 指标排名
  record: `${APICUS}/customerServiceRecord`, // 用户进线
  incomeReport: `${APICUS}/repeatIncomeReport` // 服务商重复进线
}
// 在线客服 成员管理 => 在线客服登录
export const ServicerLogin = {
  signIn: (reqData) => fetch.post(`${APICUS}/staffRegistrationRecord/add`, reqData),
  signOut: (reqData) => fetch.post(`${APICUS}/staffRegistrationRecord/signOut`, reqData),
  getCurrentDayReceptionNum: () => fetch.get(`${APICUS}/staffRegistrationRecord/getCurrentDayReceptionNum`)
}

// 在线客服 => 在线客服列表
export const OnlineServicer = {
  reqList: (params) => fetch.get(`${APICUS}/staffRegistrationRecord/page`, { params }),
  reqLogout: reqData => fetch.post(`${APICUS}/staffRegistrationRecord/batchSignOut`, reqData),
  sysUserUrl: `${APICUS}/public/getCustomerStaffForSelect`,
  selectServiceName: `${APICUS}/selectPage`
}

// 工单管理 => 录单
export const RecordSheet = {
  // 获取运单详情
  getWaybillDetail(waybillNo) {
    return fetch.get(`${moduleList.thirdService}/waybill/commonWaybillListByWaybillNos?waybillNos=${waybillNo}`)
  },
  // 获取运单列表
  reqWaybillList(params) {
    return fetch.get(`${APICUS}/waybill/cs/one-month/info`, { params })
  },
  // 物流跟踪
  traceDataList(waybillNo, isAllPod) {
    return fetch.get(`${moduleList.thirdService}/ops/podTrackingList?isAllPod=${isAllPod ? 1 : 2}&waybillNos=${waybillNo}`)
  },
  // 获取录单一级类型
  getFirstType() {
    return fetch.get(`${firstTypeUrl}?isEnable=1`)
  },
  // 获取录单二级类型
  getSecondType({ id }) {
    return fetch.get(`${secondTypeUrl}?isEnable=1&firstId=${id}`)
  },
  // 获取录单基础数据
  getInfoByInput: reqData => fetch.post(`${APICUS}/getInfoByInput`, reqData),

  // 新增工单
  reqSave(reqData) {
    return fetch.post(`${APICUS}/save`, reqData)
  },
  // 工单催单
  reqReminder(reqData) {
    return fetch.post(`${APICUS}/processBySave`, reqData)
  },
  // 校验工单是否存在
  reqWorkOrder(params) {
    return fetch.get(`${APICUS}/getWorkOrder`, { params })
  },
  // 通过网点编码获取责任网点信息
  reqResponsibleNetwork(params) {
    return fetch.get(`${APICUS}/responsibleNetworkCode?` + params)
  },
  // 通过网点编码获取网点列表
  getAcceptNetwork(reqData) {
    return fetch.post(`${APICUS}/getAcceptNetworkByType`, reqData)
    // return fetch.post(`${APICUS}/getAcceptNetwork`, reqData)
  },
  // 根据员工code客服详情(或者分机号和声通技能组)
  reqServiceStaff(params) {
    return fetch.get(`${APICUS}/detail`, { params })
  },
  // 工单处理全部记录列表
  reqAllProblemList(waybillNo) {
    return fetch.post(`${APICUS}/getProblemRecords?waybillNo=` + waybillNo)
  }
}
// 一级类型列表获取， 接口缓存无分页
export const firstTypeUrl = `${APICUS}/workOrderType/list/workOrderFirstType`
// er级类型列表获取， 接口缓存无分页
export const secondTypeUrl = `${APICUS}/workOrderType/list/workOrderFirstType`

export const sysUserUrl = `${APICUS}/public/getCustomerStaffForSelect`

// 外包客服 => 外包服务评价-汇总
export const ServiceEvaluationTotalout = {
  reqList: params => fetch.post(`${moduleList.outCustomerService}/evaluationReportPage`,  params ),
  selectServiceName: `${moduleList.serviceManagement}/selectPage`
}
// 外包客服 => 外包服务评价-评价明细
export const OutServiceEvaluationDetail = {
  reqList: (params) => fetch.get(`${moduleList.outCustomerService}/evaluationPage`, { params }),
  sysArea: `${APICUS}/sysArea/select`,
  // 导出
  reqExcel: params => fetch.get(`${moduleList.outCustomerService}/evaluationPageExport`, { params, responseType: 'arraybuffer' }, { handle: true })
}

// 外包客服 => 外包服务指标
export const OutServiceOverall = {
  reqList: params => fetch.get(`${moduleList.outCustomerService}/overallServiceIndicatorsPage`, { params }),
  selectServiceName: `${moduleList.serviceManagement}/selectPage`
}

// 外包客服 => 个人服务指标
export const OutPersonalService = {
  reqList: params => fetch.get(`${moduleList.outCustomerService}/personalServicePage`, { params }),
  selectServiceName: `${moduleList.serviceManagement}/selectPage`
}
export const OutServiceRank = {
  reqList: params => fetch.post(`${moduleList.report}/onlineServiceAssessReport/pageForService`, params),
  selectServiceName: `${moduleList.serviceManagement}/selectPage`
}

// 客服 => 服务商普通工单
export const ServiceProviderOrdinaryOrder = {
  reqList: (params) => fetch.post(`${moduleList.workOrder}/pageService`, params),
  // 多页面共用详情页面
  reqDetail: (params) => fetch.get(`${moduleList.workOrderInfo}/serviceDetail?id=${params.id}`),
  // 导出
  reqExcel: params => fetch.post(`${moduleList.workOrder}/exportService`, params, { handle: true, responseType: 'arraybuffer' }),
  // 一级类型列表获取， 接口缓存无分页
  firstTypeUrl: `${APICUS}/workOrderType/list/workOrderFirstType`,
  // er级类型列表获取， 接口缓存无分页
  secondTypeUrl: `${APICUS}/workOrderType/list/workOrderSecondType`
}

// 客服 => 服务商理赔工单
export const ServiceProviderClaimOrder = {
  reqList: (params) => fetch.post(`${moduleList.claimManage}/pageService`, params),
  // 多页面共用详情页面
  reqDetail: (params) => fetch.get(`${moduleList.claimWorkOrderInfo}/serviceDetail?id=${params.id}`),
  // 导出
  reqExcel: params => fetch.post(`${moduleList.claimManage}/exportService`, params, { handle: true, responseType: 'arraybuffer' }),
  // 一级类型列表获取， 接口缓存无分页
  firstTypeUrl: `${APICUS}/workOrderType/list/workOrderFirstType`,
  // er级类型列表获取， 接口缓存无分页
  secondTypeUrl: `${APICUS}/workOrderType/list/workOrderSecondType`
}
export const DailyReportOfCustomerService = {
  reqList: params => fetch.get(`${moduleList.customerIncomeStatistics}/customerDayPageByService`, { params }),
  selectServiceName: `${moduleList.serviceManagement}/selectPage`,
  reqAllData(params) {
    return fetch.get(`${moduleList.customerIncomeStatistics}/customerDayReceptionNumByService`, { params })
  }
}
export const RealTimeCustomerService = {
  reqList: params => fetch.get(`${moduleList.customerIncomeStatistics}/customerRealTimePageByService`, { params }),
  selectServiceName: `${moduleList.serviceManagement}/selectPage`,
  reqAllData(params) {
    return fetch.get(`${moduleList.customerIncomeStatistics}/customerRealTimeReceptionNumByService`, { params })
  }
}
export const CustomerIncomingInfoReport = {
  reqList: params => fetch.post(`${moduleList.record}/page`, params ),
  reqExcel(params) {
    return fetch.post(`${moduleList.record}/pageExport`, params, { handle: true, responseType: 'arraybuffer' })
  }
}

export const RepeatIncomingReport = {
  reqList: params => fetch.post(`${moduleList.incomeReport}/page`, params ),
  reqExcel(params) {
    return fetch.post(`${moduleList.incomeReport}/pageExport`, params, { handle: true, responseType: 'arraybuffer' })
  }
}
